// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/infer/v1/infer.proto" (package "agency.infer.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Struct } from "../../../google/protobuf/struct";
import { ProviderHints } from "../../context/v1/context";
import { ToolDescriptor } from "../../tool/v1/tool";
import { Message } from "../../session/v1/session";
/**
 * InferRequest requests LLM inference.
 *
 * @generated from protobuf message agency.infer.v1.InferRequest
 */
export interface InferRequest {
    /**
     * model_id is the model to use for inference.
     *
     * @generated from protobuf field: string model_id = 1
     */
    modelId: string;
    /**
     * messages are the conversation messages.
     *
     * @generated from protobuf field: repeated agency.session.v1.Message messages = 2
     */
    messages: Message[];
    /**
     * system_prompt is the system instruction (optional if in messages).
     *
     * @generated from protobuf field: string system_prompt = 3
     */
    systemPrompt: string;
    /**
     * tools are available tools for this request.
     *
     * @generated from protobuf field: repeated agency.tool.v1.ToolDescriptor tools = 4
     */
    tools: ToolDescriptor[];
    /**
     * tool_choice controls tool selection behavior.
     *
     * @generated from protobuf field: agency.infer.v1.ToolChoice tool_choice = 5
     */
    toolChoice?: ToolChoice;
    /**
     * temperature controls randomness (0.0-2.0).
     *
     * @generated from protobuf field: float temperature = 6
     */
    temperature: number;
    /**
     * max_tokens is the maximum response tokens (0 = model default).
     *
     * @generated from protobuf field: int32 max_tokens = 7
     */
    maxTokens: number;
    /**
     * top_p is nucleus sampling threshold (0.0-1.0).
     *
     * @generated from protobuf field: float top_p = 8
     */
    topP: number;
    /**
     * frequency_penalty reduces repetition (-2.0 to 2.0).
     *
     * @generated from protobuf field: float frequency_penalty = 9
     */
    frequencyPenalty: number;
    /**
     * presence_penalty encourages topic diversity (-2.0 to 2.0).
     *
     * @generated from protobuf field: float presence_penalty = 10
     */
    presencePenalty: number;
    /**
     * stop_sequences are sequences that halt generation.
     *
     * @generated from protobuf field: repeated string stop_sequences = 11
     */
    stopSequences: string[];
    /**
     * enable_thinking enables extended thinking for supported models.
     *
     * @generated from protobuf field: bool enable_thinking = 12
     */
    enableThinking: boolean;
    /**
     * stream indicates if streaming is requested.
     *
     * @generated from protobuf field: bool stream = 13
     */
    stream: boolean;
    /**
     * session_id is the session this request belongs to.
     *
     * @generated from protobuf field: string session_id = 14
     */
    sessionId: string;
    /**
     * turn_id is the turn this request belongs to.
     *
     * @generated from protobuf field: string turn_id = 15
     */
    turnId: string;
    /**
     * response_format specifies output format constraints.
     *
     * @generated from protobuf field: agency.infer.v1.ResponseFormat response_format = 16
     */
    responseFormat?: ResponseFormat;
    /**
     * seed is the random seed for reproducibility (optional).
     *
     * @generated from protobuf field: int64 seed = 17
     */
    seed: bigint;
    /**
     * metadata contains additional request context.
     *
     * @generated from protobuf field: map<string, string> metadata = 18
     */
    metadata: {
        [key: string]: string;
    };
    /**
     * timeout_seconds overrides default request timeout.
     *
     * @generated from protobuf field: int32 timeout_seconds = 19
     */
    timeoutSeconds: number;
    /**
     * provider_hints carries cache optimization metadata from the contextualizer.
     * Provider-specific LLM clients use this to inject cache-control markers
     * (e.g. Anthropic cache_control breakpoints, OpenAI prefix cache boundary).
     * Nil means no cache hints available — clients MUST treat nil as no-op.
     *
     * @generated from protobuf field: agency.context.v1.ProviderHints provider_hints = 20
     */
    providerHints?: ProviderHints;
}
/**
 * ToolChoice controls how the model selects tools.
 *
 * @generated from protobuf message agency.infer.v1.ToolChoice
 */
export interface ToolChoice {
    /**
     * Choice type (one of these will be set).
     *
     * @generated from protobuf oneof: choice
     */
    choice: {
        oneofKind: "auto";
        /**
         * auto allows the model to decide whether to call tools.
         *
         * @generated from protobuf field: bool auto = 1
         */
        auto: boolean;
    } | {
        oneofKind: "none";
        /**
         * none prevents the model from calling any tools.
         *
         * @generated from protobuf field: bool none = 2
         */
        none: boolean;
    } | {
        oneofKind: "required";
        /**
         * required forces the model to call at least one tool.
         *
         * @generated from protobuf field: bool required = 3
         */
        required: boolean;
    } | {
        oneofKind: "specificTool";
        /**
         * specific_tool forces a specific tool to be called.
         *
         * @generated from protobuf field: string specific_tool = 4
         */
        specificTool: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * ResponseFormat specifies output format constraints.
 *
 * @generated from protobuf message agency.infer.v1.ResponseFormat
 */
export interface ResponseFormat {
    /**
     * type is the format type.
     *
     * @generated from protobuf field: agency.infer.v1.ResponseFormatType type = 1
     */
    type: ResponseFormatType;
    /**
     * json_schema is the JSON Schema for structured output (if type is JSON_SCHEMA).
     *
     * @generated from protobuf field: google.protobuf.Struct json_schema = 2
     */
    jsonSchema?: Struct;
}
/**
 * InferResponse is the inference result.
 *
 * @generated from protobuf message agency.infer.v1.InferResponse
 */
export interface InferResponse {
    /**
     * session_id is the session this response belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this response belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * message is the assistant's response.
     *
     * @generated from protobuf field: agency.session.v1.Message message = 3
     */
    message?: Message;
    /**
     * finish_reason explains why generation stopped.
     *
     * @generated from protobuf field: agency.infer.v1.FinishReason finish_reason = 4
     */
    finishReason: FinishReason;
    /**
     * usage contains token consumption details.
     *
     * @generated from protobuf field: agency.infer.v1.Usage usage = 5
     */
    usage?: Usage;
    /**
     * model_id is the model that generated this response.
     *
     * @generated from protobuf field: string model_id = 6
     */
    modelId: string;
    /**
     * created_at is when the response was generated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * latency_ms is the request duration in milliseconds.
     *
     * @generated from protobuf field: int64 latency_ms = 8
     */
    latencyMs: bigint;
    /**
     * metadata contains additional response context.
     *
     * @generated from protobuf field: map<string, string> metadata = 9
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * Usage contains token consumption details.
 *
 * @generated from protobuf message agency.infer.v1.Usage
 */
export interface Usage {
    /**
     * prompt_tokens is the input token count.
     *
     * @generated from protobuf field: int32 prompt_tokens = 1
     */
    promptTokens: number;
    /**
     * completion_tokens is the output token count.
     *
     * @generated from protobuf field: int32 completion_tokens = 2
     */
    completionTokens: number;
    /**
     * total_tokens is the sum of prompt and completion tokens.
     *
     * @generated from protobuf field: int32 total_tokens = 3
     */
    totalTokens: number;
    /**
     * thinking_tokens is the extended thinking token count (if applicable).
     *
     * @generated from protobuf field: int32 thinking_tokens = 4
     */
    thinkingTokens: number;
    /**
     * cached_tokens is the number of prompt tokens served from the provider's
     * prompt cache (cache hit). Populated from provider response:
     *   Anthropic: usage.cache_read_input_tokens
     *   OpenAI:    usage.prompt_tokens_details.cached_tokens
     * Zero when the provider does not report cache hits or no cache was used.
     *
     * @generated from protobuf field: int32 cached_tokens = 5
     */
    cachedTokens: number;
    /**
     * cache_write_tokens is the number of prompt tokens written to the provider's
     * prompt cache on a cache miss (first call with a new stable prefix).
     * Populated from provider response:
     *   Anthropic: usage.cache_creation_input_tokens (billed at 1.25x)
     *   OpenAI:    not reported (always zero)
     * Zero when the provider does not report cache writes or no cache was written.
     *
     * @generated from protobuf field: int32 cache_write_tokens = 6
     */
    cacheWriteTokens: number;
}
/**
 * TokenChunk represents a streaming token delta.
 *
 * @generated from protobuf message agency.infer.v1.TokenChunk
 */
export interface TokenChunk {
    /**
     * session_id is the session this chunk belongs to.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * turn_id is the turn this chunk belongs to.
     *
     * @generated from protobuf field: string turn_id = 2
     */
    turnId: string;
    /**
     * delta is the incremental text content (set when content_type is TEXT or THINKING).
     *
     * @generated from protobuf field: string delta = 3
     */
    delta: string;
    /**
     * content_type indicates the type of content.
     *
     * @generated from protobuf field: agency.infer.v1.ContentType content_type = 4
     */
    contentType: ContentType;
    /**
     * index is the content block index (for multi-part responses).
     *
     * @generated from protobuf field: int32 index = 5
     */
    index: number;
    /**
     * finish_reason is set on the final chunk (if applicable).
     *
     * @generated from protobuf field: agency.infer.v1.FinishReason finish_reason = 6
     */
    finishReason: FinishReason;
    /**
     * timestamp is when this chunk was generated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 7
     */
    timestamp?: Timestamp;
    /**
     * tool_call carries structured tool call data (set when content_type is TOOL_CALL).
     *
     * @generated from protobuf field: agency.infer.v1.ToolCallDelta tool_call = 8
     */
    toolCall?: ToolCallDelta;
    /**
     * usage is populated on the final chunk only (when finish_reason is set).
     * Zero value on all other chunks — consumers must not accumulate across chunks.
     * Sourced from stream_options.include_usage=true (OpenAI) or equivalent.
     *
     * @generated from protobuf field: agency.infer.v1.Usage usage = 9
     */
    usage?: Usage;
    /**
     * error_message is the provider error text. Set only on the final chunk
     * when finish_reason is FINISH_REASON_ERROR; empty otherwise.
     *
     * @generated from protobuf field: string error_message = 10
     */
    errorMessage: string;
}
/**
 * ToolCallDelta is a single streaming fragment of a tool call.
 * Chunks sharing the same index belong to the same tool call; accumulate
 * function.arguments across chunks to reconstruct the complete arguments JSON.
 *
 * @generated from protobuf message agency.infer.v1.ToolCallDelta
 */
export interface ToolCallDelta {
    /**
     * index identifies the tool call within a parallel set (0-based).
     *
     * @generated from protobuf field: int32 index = 1
     */
    index: number;
    /**
     * id is the tool call identifier (set only on the first chunk for this index).
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * function carries the function name and incremental arguments.
     *
     * @generated from protobuf field: agency.infer.v1.ToolCallFunctionDelta function = 3
     */
    function?: ToolCallFunctionDelta;
}
/**
 * ToolCallFunctionDelta is the function fragment within a ToolCallDelta.
 *
 * @generated from protobuf message agency.infer.v1.ToolCallFunctionDelta
 */
export interface ToolCallFunctionDelta {
    /**
     * name is the function name (set only on the first chunk for this tool call).
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * arguments is an incremental JSON fragment; accumulate across chunks.
     *
     * @generated from protobuf field: string arguments = 2
     */
    arguments: string;
}
/**
 * ResponseFormatType defines output format types.
 *
 * @generated from protobuf enum agency.infer.v1.ResponseFormatType
 */
export enum ResponseFormatType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: RESPONSE_FORMAT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * TEXT is plain text output (default).
     *
     * @generated from protobuf enum value: RESPONSE_FORMAT_TYPE_TEXT = 1;
     */
    TEXT = 1,
    /**
     * JSON_OBJECT requests JSON output without schema.
     *
     * @generated from protobuf enum value: RESPONSE_FORMAT_TYPE_JSON_OBJECT = 2;
     */
    JSON_OBJECT = 2,
    /**
     * JSON_SCHEMA requests JSON output matching a schema.
     *
     * @generated from protobuf enum value: RESPONSE_FORMAT_TYPE_JSON_SCHEMA = 3;
     */
    JSON_SCHEMA = 3
}
/**
 * FinishReason explains why generation stopped.
 *
 * @generated from protobuf enum agency.infer.v1.FinishReason
 */
export enum FinishReason {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: FINISH_REASON_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * STOP indicates natural completion.
     *
     * @generated from protobuf enum value: FINISH_REASON_STOP = 1;
     */
    STOP = 1,
    /**
     * LENGTH indicates max_tokens limit reached.
     *
     * @generated from protobuf enum value: FINISH_REASON_LENGTH = 2;
     */
    LENGTH = 2,
    /**
     * TOOL_CALLS indicates the model wants to call tools.
     *
     * @generated from protobuf enum value: FINISH_REASON_TOOL_CALLS = 3;
     */
    TOOL_CALLS = 3,
    /**
     * CONTENT_FILTER indicates content policy violation.
     *
     * @generated from protobuf enum value: FINISH_REASON_CONTENT_FILTER = 4;
     */
    CONTENT_FILTER = 4,
    /**
     * ERROR indicates inference error.
     *
     * @generated from protobuf enum value: FINISH_REASON_ERROR = 5;
     */
    ERROR = 5,
    /**
     * CANCELLED indicates user cancellation.
     *
     * @generated from protobuf enum value: FINISH_REASON_CANCELLED = 6;
     */
    CANCELLED = 6
}
/**
 * ContentType indicates the type of streaming content.
 *
 * @generated from protobuf enum agency.infer.v1.ContentType
 */
export enum ContentType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: CONTENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * TEXT is plain text content.
     *
     * @generated from protobuf enum value: CONTENT_TYPE_TEXT_CONTENT = 1;
     */
    TEXT_CONTENT = 1,
    /**
     * THINKING is extended thinking content.
     *
     * @generated from protobuf enum value: CONTENT_TYPE_THINKING = 2;
     */
    THINKING = 2,
    /**
     * TOOL_CALL is a tool call definition.
     *
     * @generated from protobuf enum value: CONTENT_TYPE_TOOL_CALL = 3;
     */
    TOOL_CALL = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class InferRequest$Type extends MessageType<InferRequest> {
    constructor() {
        super("agency.infer.v1.InferRequest", [
            { no: 1, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Message, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "1000" } } } },
            { no: 3, name: "system_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "524288" } } } },
            { no: 4, name: "tools", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ToolDescriptor, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 5, name: "tool_choice", kind: "message", T: () => ToolChoice },
            { no: 6, name: "temperature", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 2, gte: 0 } } } },
            { no: 7, name: "max_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100000, gte: 0 } } } },
            { no: 8, name: "top_p", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 9, name: "frequency_penalty", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 2, gte: -2 } } } },
            { no: 10, name: "presence_penalty", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 2, gte: -2 } } } },
            { no: 11, name: "stop_sequences", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "10", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 12, name: "enable_thinking", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "stream", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 14, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 15, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 16, name: "response_format", kind: "message", T: () => ResponseFormat },
            { no: 17, name: "seed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 18, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } },
            { no: 19, name: "timeout_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 604800, gte: 1 } } } },
            { no: 20, name: "provider_hints", kind: "message", T: () => ProviderHints }
        ]);
    }
    create(value?: PartialMessage<InferRequest>): InferRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.modelId = "";
        message.messages = [];
        message.systemPrompt = "";
        message.tools = [];
        message.temperature = 0;
        message.maxTokens = 0;
        message.topP = 0;
        message.frequencyPenalty = 0;
        message.presencePenalty = 0;
        message.stopSequences = [];
        message.enableThinking = false;
        message.stream = false;
        message.sessionId = "";
        message.turnId = "";
        message.seed = 0n;
        message.metadata = {};
        message.timeoutSeconds = 0;
        if (value !== undefined)
            reflectionMergePartial<InferRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InferRequest): InferRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model_id */ 1:
                    message.modelId = reader.string();
                    break;
                case /* repeated agency.session.v1.Message messages */ 2:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string system_prompt */ 3:
                    message.systemPrompt = reader.string();
                    break;
                case /* repeated agency.tool.v1.ToolDescriptor tools */ 4:
                    message.tools.push(ToolDescriptor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* agency.infer.v1.ToolChoice tool_choice */ 5:
                    message.toolChoice = ToolChoice.internalBinaryRead(reader, reader.uint32(), options, message.toolChoice);
                    break;
                case /* float temperature */ 6:
                    message.temperature = reader.float();
                    break;
                case /* int32 max_tokens */ 7:
                    message.maxTokens = reader.int32();
                    break;
                case /* float top_p */ 8:
                    message.topP = reader.float();
                    break;
                case /* float frequency_penalty */ 9:
                    message.frequencyPenalty = reader.float();
                    break;
                case /* float presence_penalty */ 10:
                    message.presencePenalty = reader.float();
                    break;
                case /* repeated string stop_sequences */ 11:
                    message.stopSequences.push(reader.string());
                    break;
                case /* bool enable_thinking */ 12:
                    message.enableThinking = reader.bool();
                    break;
                case /* bool stream */ 13:
                    message.stream = reader.bool();
                    break;
                case /* string session_id */ 14:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 15:
                    message.turnId = reader.string();
                    break;
                case /* agency.infer.v1.ResponseFormat response_format */ 16:
                    message.responseFormat = ResponseFormat.internalBinaryRead(reader, reader.uint32(), options, message.responseFormat);
                    break;
                case /* int64 seed */ 17:
                    message.seed = reader.int64().toBigInt();
                    break;
                case /* map<string, string> metadata */ 18:
                    this.binaryReadMap18(message.metadata, reader, options);
                    break;
                case /* int32 timeout_seconds */ 19:
                    message.timeoutSeconds = reader.int32();
                    break;
                case /* agency.context.v1.ProviderHints provider_hints */ 20:
                    message.providerHints = ProviderHints.internalBinaryRead(reader, reader.uint32(), options, message.providerHints);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap18(map: InferRequest["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof InferRequest["metadata"] | undefined, val: InferRequest["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.infer.v1.InferRequest.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: InferRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string model_id = 1; */
        if (message.modelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.modelId);
        /* repeated agency.session.v1.Message messages = 2; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string system_prompt = 3; */
        if (message.systemPrompt !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.systemPrompt);
        /* repeated agency.tool.v1.ToolDescriptor tools = 4; */
        for (let i = 0; i < message.tools.length; i++)
            ToolDescriptor.internalBinaryWrite(message.tools[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.infer.v1.ToolChoice tool_choice = 5; */
        if (message.toolChoice)
            ToolChoice.internalBinaryWrite(message.toolChoice, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* float temperature = 6; */
        if (message.temperature !== 0)
            writer.tag(6, WireType.Bit32).float(message.temperature);
        /* int32 max_tokens = 7; */
        if (message.maxTokens !== 0)
            writer.tag(7, WireType.Varint).int32(message.maxTokens);
        /* float top_p = 8; */
        if (message.topP !== 0)
            writer.tag(8, WireType.Bit32).float(message.topP);
        /* float frequency_penalty = 9; */
        if (message.frequencyPenalty !== 0)
            writer.tag(9, WireType.Bit32).float(message.frequencyPenalty);
        /* float presence_penalty = 10; */
        if (message.presencePenalty !== 0)
            writer.tag(10, WireType.Bit32).float(message.presencePenalty);
        /* repeated string stop_sequences = 11; */
        for (let i = 0; i < message.stopSequences.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.stopSequences[i]);
        /* bool enable_thinking = 12; */
        if (message.enableThinking !== false)
            writer.tag(12, WireType.Varint).bool(message.enableThinking);
        /* bool stream = 13; */
        if (message.stream !== false)
            writer.tag(13, WireType.Varint).bool(message.stream);
        /* string session_id = 14; */
        if (message.sessionId !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 15; */
        if (message.turnId !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.turnId);
        /* agency.infer.v1.ResponseFormat response_format = 16; */
        if (message.responseFormat)
            ResponseFormat.internalBinaryWrite(message.responseFormat, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* int64 seed = 17; */
        if (message.seed !== 0n)
            writer.tag(17, WireType.Varint).int64(message.seed);
        /* map<string, string> metadata = 18; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(18, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        /* int32 timeout_seconds = 19; */
        if (message.timeoutSeconds !== 0)
            writer.tag(19, WireType.Varint).int32(message.timeoutSeconds);
        /* agency.context.v1.ProviderHints provider_hints = 20; */
        if (message.providerHints)
            ProviderHints.internalBinaryWrite(message.providerHints, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.InferRequest
 */
export const InferRequest = new InferRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolChoice$Type extends MessageType<ToolChoice> {
    constructor() {
        super("agency.infer.v1.ToolChoice", [
            { no: 1, name: "auto", kind: "scalar", oneof: "choice", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "none", kind: "scalar", oneof: "choice", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "required", kind: "scalar", oneof: "choice", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "specific_tool", kind: "scalar", oneof: "choice", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolChoice>): ToolChoice {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.choice = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ToolChoice>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolChoice): ToolChoice {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool auto */ 1:
                    message.choice = {
                        oneofKind: "auto",
                        auto: reader.bool()
                    };
                    break;
                case /* bool none */ 2:
                    message.choice = {
                        oneofKind: "none",
                        none: reader.bool()
                    };
                    break;
                case /* bool required */ 3:
                    message.choice = {
                        oneofKind: "required",
                        required: reader.bool()
                    };
                    break;
                case /* string specific_tool */ 4:
                    message.choice = {
                        oneofKind: "specificTool",
                        specificTool: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolChoice, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool auto = 1; */
        if (message.choice.oneofKind === "auto")
            writer.tag(1, WireType.Varint).bool(message.choice.auto);
        /* bool none = 2; */
        if (message.choice.oneofKind === "none")
            writer.tag(2, WireType.Varint).bool(message.choice.none);
        /* bool required = 3; */
        if (message.choice.oneofKind === "required")
            writer.tag(3, WireType.Varint).bool(message.choice.required);
        /* string specific_tool = 4; */
        if (message.choice.oneofKind === "specificTool")
            writer.tag(4, WireType.LengthDelimited).string(message.choice.specificTool);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.ToolChoice
 */
export const ToolChoice = new ToolChoice$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResponseFormat$Type extends MessageType<ResponseFormat> {
    constructor() {
        super("agency.infer.v1.ResponseFormat", [
            { no: 1, name: "type", kind: "enum", T: () => ["agency.infer.v1.ResponseFormatType", ResponseFormatType, "RESPONSE_FORMAT_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "json_schema", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<ResponseFormat>): ResponseFormat {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        if (value !== undefined)
            reflectionMergePartial<ResponseFormat>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResponseFormat): ResponseFormat {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.infer.v1.ResponseFormatType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* google.protobuf.Struct json_schema */ 2:
                    message.jsonSchema = Struct.internalBinaryRead(reader, reader.uint32(), options, message.jsonSchema);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResponseFormat, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.infer.v1.ResponseFormatType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* google.protobuf.Struct json_schema = 2; */
        if (message.jsonSchema)
            Struct.internalBinaryWrite(message.jsonSchema, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.ResponseFormat
 */
export const ResponseFormat = new ResponseFormat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InferResponse$Type extends MessageType<InferResponse> {
    constructor() {
        super("agency.infer.v1.InferResponse", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "message", kind: "message", T: () => Message, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "finish_reason", kind: "enum", T: () => ["agency.infer.v1.FinishReason", FinishReason, "FINISH_REASON_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "usage", kind: "message", T: () => Usage, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "latency_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 9, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<InferResponse>): InferResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.finishReason = 0;
        message.modelId = "";
        message.latencyMs = 0n;
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<InferResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: InferResponse): InferResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* agency.session.v1.Message message */ 3:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                case /* agency.infer.v1.FinishReason finish_reason */ 4:
                    message.finishReason = reader.int32();
                    break;
                case /* agency.infer.v1.Usage usage */ 5:
                    message.usage = Usage.internalBinaryRead(reader, reader.uint32(), options, message.usage);
                    break;
                case /* string model_id */ 6:
                    message.modelId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* int64 latency_ms */ 8:
                    message.latencyMs = reader.int64().toBigInt();
                    break;
                case /* map<string, string> metadata */ 9:
                    this.binaryReadMap9(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: InferResponse["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof InferResponse["metadata"] | undefined, val: InferResponse["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.infer.v1.InferResponse.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: InferResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* agency.session.v1.Message message = 3; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* agency.infer.v1.FinishReason finish_reason = 4; */
        if (message.finishReason !== 0)
            writer.tag(4, WireType.Varint).int32(message.finishReason);
        /* agency.infer.v1.Usage usage = 5; */
        if (message.usage)
            Usage.internalBinaryWrite(message.usage, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string model_id = 6; */
        if (message.modelId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.modelId);
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* int64 latency_ms = 8; */
        if (message.latencyMs !== 0n)
            writer.tag(8, WireType.Varint).int64(message.latencyMs);
        /* map<string, string> metadata = 9; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.InferResponse
 */
export const InferResponse = new InferResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Usage$Type extends MessageType<Usage> {
    constructor() {
        super("agency.infer.v1.Usage", [
            { no: 1, name: "prompt_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 2, name: "completion_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "total_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "thinking_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 5, name: "cached_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 6, name: "cache_write_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<Usage>): Usage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.promptTokens = 0;
        message.completionTokens = 0;
        message.totalTokens = 0;
        message.thinkingTokens = 0;
        message.cachedTokens = 0;
        message.cacheWriteTokens = 0;
        if (value !== undefined)
            reflectionMergePartial<Usage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Usage): Usage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 prompt_tokens */ 1:
                    message.promptTokens = reader.int32();
                    break;
                case /* int32 completion_tokens */ 2:
                    message.completionTokens = reader.int32();
                    break;
                case /* int32 total_tokens */ 3:
                    message.totalTokens = reader.int32();
                    break;
                case /* int32 thinking_tokens */ 4:
                    message.thinkingTokens = reader.int32();
                    break;
                case /* int32 cached_tokens */ 5:
                    message.cachedTokens = reader.int32();
                    break;
                case /* int32 cache_write_tokens */ 6:
                    message.cacheWriteTokens = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Usage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 prompt_tokens = 1; */
        if (message.promptTokens !== 0)
            writer.tag(1, WireType.Varint).int32(message.promptTokens);
        /* int32 completion_tokens = 2; */
        if (message.completionTokens !== 0)
            writer.tag(2, WireType.Varint).int32(message.completionTokens);
        /* int32 total_tokens = 3; */
        if (message.totalTokens !== 0)
            writer.tag(3, WireType.Varint).int32(message.totalTokens);
        /* int32 thinking_tokens = 4; */
        if (message.thinkingTokens !== 0)
            writer.tag(4, WireType.Varint).int32(message.thinkingTokens);
        /* int32 cached_tokens = 5; */
        if (message.cachedTokens !== 0)
            writer.tag(5, WireType.Varint).int32(message.cachedTokens);
        /* int32 cache_write_tokens = 6; */
        if (message.cacheWriteTokens !== 0)
            writer.tag(6, WireType.Varint).int32(message.cacheWriteTokens);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.Usage
 */
export const Usage = new Usage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TokenChunk$Type extends MessageType<TokenChunk> {
    constructor() {
        super("agency.infer.v1.TokenChunk", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "turn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 3, name: "delta", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "content_type", kind: "enum", T: () => ["agency.infer.v1.ContentType", ContentType, "CONTENT_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "index", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 6, name: "finish_reason", kind: "enum", T: () => ["agency.infer.v1.FinishReason", FinishReason, "FINISH_REASON_"] },
            { no: 7, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "tool_call", kind: "message", T: () => ToolCallDelta },
            { no: 9, name: "usage", kind: "message", T: () => Usage },
            { no: 10, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TokenChunk>): TokenChunk {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.turnId = "";
        message.delta = "";
        message.contentType = 0;
        message.index = 0;
        message.finishReason = 0;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<TokenChunk>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TokenChunk): TokenChunk {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string turn_id */ 2:
                    message.turnId = reader.string();
                    break;
                case /* string delta */ 3:
                    message.delta = reader.string();
                    break;
                case /* agency.infer.v1.ContentType content_type */ 4:
                    message.contentType = reader.int32();
                    break;
                case /* int32 index */ 5:
                    message.index = reader.int32();
                    break;
                case /* agency.infer.v1.FinishReason finish_reason */ 6:
                    message.finishReason = reader.int32();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 7:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* agency.infer.v1.ToolCallDelta tool_call */ 8:
                    message.toolCall = ToolCallDelta.internalBinaryRead(reader, reader.uint32(), options, message.toolCall);
                    break;
                case /* agency.infer.v1.Usage usage */ 9:
                    message.usage = Usage.internalBinaryRead(reader, reader.uint32(), options, message.usage);
                    break;
                case /* string error_message */ 10:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TokenChunk, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string turn_id = 2; */
        if (message.turnId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.turnId);
        /* string delta = 3; */
        if (message.delta !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.delta);
        /* agency.infer.v1.ContentType content_type = 4; */
        if (message.contentType !== 0)
            writer.tag(4, WireType.Varint).int32(message.contentType);
        /* int32 index = 5; */
        if (message.index !== 0)
            writer.tag(5, WireType.Varint).int32(message.index);
        /* agency.infer.v1.FinishReason finish_reason = 6; */
        if (message.finishReason !== 0)
            writer.tag(6, WireType.Varint).int32(message.finishReason);
        /* google.protobuf.Timestamp timestamp = 7; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.infer.v1.ToolCallDelta tool_call = 8; */
        if (message.toolCall)
            ToolCallDelta.internalBinaryWrite(message.toolCall, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* agency.infer.v1.Usage usage = 9; */
        if (message.usage)
            Usage.internalBinaryWrite(message.usage, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 10; */
        if (message.errorMessage !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.TokenChunk
 */
export const TokenChunk = new TokenChunk$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCallDelta$Type extends MessageType<ToolCallDelta> {
    constructor() {
        super("agency.infer.v1.ToolCallDelta", [
            { no: 1, name: "index", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "function", kind: "message", T: () => ToolCallFunctionDelta }
        ]);
    }
    create(value?: PartialMessage<ToolCallDelta>): ToolCallDelta {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.index = 0;
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ToolCallDelta>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCallDelta): ToolCallDelta {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 index */ 1:
                    message.index = reader.int32();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* agency.infer.v1.ToolCallFunctionDelta function */ 3:
                    message.function = ToolCallFunctionDelta.internalBinaryRead(reader, reader.uint32(), options, message.function);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCallDelta, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 index = 1; */
        if (message.index !== 0)
            writer.tag(1, WireType.Varint).int32(message.index);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* agency.infer.v1.ToolCallFunctionDelta function = 3; */
        if (message.function)
            ToolCallFunctionDelta.internalBinaryWrite(message.function, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.ToolCallDelta
 */
export const ToolCallDelta = new ToolCallDelta$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCallFunctionDelta$Type extends MessageType<ToolCallFunctionDelta> {
    constructor() {
        super("agency.infer.v1.ToolCallFunctionDelta", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "arguments", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ToolCallFunctionDelta>): ToolCallFunctionDelta {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.arguments = "";
        if (value !== undefined)
            reflectionMergePartial<ToolCallFunctionDelta>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCallFunctionDelta): ToolCallFunctionDelta {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string arguments */ 2:
                    message.arguments = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCallFunctionDelta, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string arguments = 2; */
        if (message.arguments !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.arguments);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.infer.v1.ToolCallFunctionDelta
 */
export const ToolCallFunctionDelta = new ToolCallFunctionDelta$Type();
